<template>
  <CardWithTitle
    :request-status="requestStatus"
    :item-id="itemId"
    :options-data="baseCardOptions"
    @call-option-menu="callOptionMenu"
    @reload="reload"
  >
    <v-row class="influencers-list">
      <SingleSelect
        v-model="selectedLimit"
        class="select"
        :items="limitOptions"
        :searchable="false"
        :value="10"
        :clearable="false"
      />
      <div
        v-for="(influencer, index) in influencersList"
        :key="influencer.uid"
        class="influencers-list-item"
      >
        <div class="influencers-list-item__position">
          #{{ index + 1 }}
        </div>

        <div class="influencers-list-item__icon pa-0 ma-0">
          <a
            :href="influencer.url"
            target="_blank"
          >
            <component
              :is="getChannelComponent(influencer.channel.toLowerCase())"
              :channel="influencer.channel.toLowerCase()"
            />
          </a>
        </div>

        <div class="influencers-list-item__avatar">
          <StUserAvatar
            :user="influencer"
            user-image-path="profile_picture"
            size="30"
            :tooltip="influencer.name"
          />
        </div>

        <div class="influencers-list-item__name text-truncate">
          <span v-tooltip="influencer.name">
            {{ influencer.name }}
          </span>
        </div>
      </div>
    </v-row>

    <template #top-right-slot>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import SingleSelect from '@/components/filter/models/SingleSelect.vue';
import { mapActions } from 'vuex';
import StUserAvatar from '@stilingue/st-user-avatar';
import channelModel from '@/mixins/channel-model';
import cardsModel from '@/mixins/cards-model';
import { findSocialIcon } from '@/utils/channels';
import EventBus from '@/utils/event-bus';
import Badge from '@/components/Badge';

export default {
  name: 'TopInfluencers',
  components: {
    CardWithTitle,
    SingleSelect,
    StUserAvatar,
    Badge,
  },
  mixins: [
    channelModel,
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      default: '',
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      influencersList: [],
      requestStatus: 'loading',
      selectedLimit: 10,
      limitOptions: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '20', value: 20 },
      ],
    };
  },
  watch: {
    selectedLimit() {
      this.getData();
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getChannelComponent(channel) {
      return findSocialIcon(channel);
    },
    reload() {
      this.getData();
    },
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'topInfluencers',
        serviceParams: { limit: this.selectedLimit },
      })
        .then(response => {
          this.influencersList = response.influencers_list;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    getChannelByInfluencer(influencer) {
      return this.getChannelColorNameAndIcon(influencer.channel);
    },
  },
};
</script>

<style lang="scss" scoped>
  .select {
    left: 25%;
    max-width: 50%;
  }

  .influencers-list-item {
    display: grid;
    grid-template-columns: 30px 48px 48px 130px;
    grid-column-gap: 10px;
    width: 100%;
    height: 35px;
    align-items: center;
    justify-content: center;

    &__icon {
      height: 53px;
      align-self: center;
      justify-self: center;
    }
  }

  .pointer {
    cursor: pointer;
  }

  @media screen and (max-width: 600px) {
    .influencers-list-item {
      grid-template-columns: 30px 40px 40px 150px;
    }
  }

  .influencers-list {
    max-width: 100%;
    height: 100%;
  }
</style>
